var _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 27.333 27.333"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.913,
    cy: 10.913,
    r: 10.913,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.913,
    cy: 10.913,
    r: 9.913
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M18.643 18.643l7.275 7.275"
  })));
}

export default __webpack_public_path__ + "59b9461c6c7c0d10ca810c3df0f2971c.svg";
export { SvgSearchButton as ReactComponent };